<template>
  <div class="main-body">
    <div class="header">收银员</div>
    <div class="out">

      <div class="search2">

          <div style="float:right">

            <el-select v-model="businessCode" placeholder="请选择商家" style="margin-right:10px">
              <el-option
                  v-for="item in arr_business"
                  :key="item.businessCode"
                  :label="item.name"
                  :value="item.businessCode">
              </el-option>
            </el-select>

            <el-button type="primary" size="mini" icon="el-icon-search" @click="getList(true)">搜索</el-button>
          </div>

        <div style="clear: both;"></div>
      </div>



      <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th" border :header-cell-style="tabHeader">


        <el-table-column prop="name" label="姓名" ></el-table-column>

        <el-table-column label="性别" >
          <template slot-scope="scope">
            <span v-if="scope.row.gender == '0'">女</span>
            <span v-if="scope.row.gender == '1'">男</span>
          </template>
        </el-table-column>

        <el-table-column label="状态" >
          <template slot-scope="scope">
            <span v-if="scope.row.status == '1'">正常</span>
            <span v-if="scope.row.status == '2'">禁用</span>
          </template>
        </el-table-column>

        <el-table-column prop="phone" label="手机" ></el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getGovernmentCode,getStaffCode} from "@/utils/auth";

export default {
  name: "Role",
  data() {
    return {

      tableLoading: false,
      showModalEditStaff: false,

      showModalAdd: false,
      showModalEdit: false,
      name: '',
      status: -1,
      tableData: null,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,


      arr_business:[],
      businessCode:'',

    }
  },
  components: {

  },
  created() {
    this.getBusiness2();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
  },
  methods: {

    // 修改table header的背景色
    tabHeader() {
      return 'color:#333;fonts-weight:bold;'
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    getSetTime(row, column, cellValue){
      return timefilters(cellValue)
    },

    getBusiness2(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/GovList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: getGovernmentCode(),
          businessType:3,
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {

              this.arr_business = response.data.data;
              if(this.arr_business.length>0){
                this.businessCode = this.arr_business[0].businessCode;
                this.getList();
              }

            }else if(response.data.error === 1){
              this.$message.error(response.data.message)
            }

          }
      )

    },

    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Cashier/GovPage",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          businessCode:this.businessCode,
        }
      }).then((response) => {
        this.tableLoading=false
        if (response.data.error == 0) {
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }
      }).catch(function (error) {
        this.tableLoading=false
        console.log(error);
      });
    },



  }
}
</script>

<style scoped>

</style>
